export default {
	"exchange.PleaseSelectTheProductInformationYouWantToRedeem": "请选择需要兑换的商品信息",
	"exchange.NoRedemptionCode": "无兑换码",
	"exchange.PleaseEnterYourAddressInformation": "请输入地址信息",
	"exchange.prompt": "提示",
	"exchange.AccordingToTheRequirementsOfNationalPoliciesTheExpressMailSentToTaiwanNeedsToFillInTheCertificateNumberPleaseFillIn": "根据国家政策要求，发往台湾地区的快件需填写证件号码，请您补充填写",
	"exchange.Cancel": "取消",
	"exchange.GoFillItOut": "去填写",
	"exchange.SorryYouDoNotMeetTheNewUserPurchaseRulesPleaseGoToTheLoveToReadPublicAccountToBuyAfterRefund": "抱歉，您不满足新用户购买规则，请退款后前往“爱阅读的叫叫”公众号购买",
	"exchange.TheProductWasRedeemedSuccessfully": "商品兑换成功！",
	"exchange.ActivationCodeRedemptionSuccessful": "激活码兑换成功！",
	"exchange.NoActivationAddress": "无激活地址！",
	"exchange.RedemptionActivationFailed": "兑换激活失败！",
	"exchange.RedeemGoods": "兑换商品",
	"exchange.ShippingAddress": "收货地址",
	"exchange.PhysicalTeachingMaterialsWillBeSentToThisAddress": "实物教材将寄送至该地址",
	"exchange.ParameterError": "参数错误!",
	"exchange.PleaseFillInTheInformation": "请填写信息",
	"exchange.NewRevenueInformation": "新增收货信息",
	"exchange.SelectAProduct": "选择商品",
	"exchange.DetailedChecklist": "详细清单",
	"exchange.ThisRedemptionIncludesTheFollowing": "本次兑换商品包含以下内容",
	"exchange.Gifts": "赠品",
	"exchange.Real": "实物",
	"exchange.Tips": "温馨提示",
	"exchange.1TheSkuOfTheSelectedProductCannotBeReplacedOnceItIsRedeemedPleaseChooseCarefully": "1、选择商品的sku一经兑换不得进行更换，请认真选择。",
	"exchange.2IfTheSkuContainsAGiftTheGiftCanBeReplacedWithin24HoursAfterTheGiftRedemptionIsSuccessfullyActivatedAndTheInstructorCanBeContactedForReplacementAndItWillNotBeReplacedAfterTheTimeout": "2、sku中若包含赠品，赠品兑换激活成功24小时之内可联系指导师进行更换，超时后不予更换。",
	"exchange.3TheGiveawayCannotBeReplacedAfterTheExperienceRecordIsGenerated": "3、赠品产生体验记录后不可更换。",
	"exchange.Customer": "客服",
	"exchange.ConfirmTheInformation": "确认信息"
}